import router from '../router'
import VueTk from '@moke/vue-tk'
import store from '@/store'
const rulers = [{
  match: '*',
  except: [
    '/user/login',
    '/exception/403',
    '/exception/404'
  ],
  handler: async function (route, next) {
    console.log(route)
    // 判断路由是否有权访问
    if (!!store.state.user && !!store.state.sessionToken) {
      let list = [
        '/',
        '/account/setting/base',
        '/account/setting/editPassWord',
        '/model/user',
        '/model/userAdmin',
        '/model/facility',
        '/model/share',
        '/model/article',
        '/model/updata',
        '/model/feedback',
        '/model/overseas',
        '/setting'
      ]
      if (list.indexOf(route.path) === -1) {
        next(false)
      }
      next(true)
    } else {
      next('/user/login')
    }
  },
  fallbackUrl: '/exception/404'
}]

VueTk.tkRouterAuth.init(rulers, router)
